import {
  DOCUMENT_CONTEXT_SERIALIZE_OPTIONS,
  SELECTION_EXPAND_OPTIONS,
  serializeSelectionContext,
} from '@aline/common';
import type { AlineEditor } from '@aline/common';
import type { Range } from 'slate';

import { getSelectionInfoFromRange } from './getSelectionInfoFromRange';

/**
 * Client-side glue from a live Aline content editor + range to the serialized
 * HTML-like Cast selection context. Bridges the editor-bound
 * `getSelectionInfoFromRange` and the editor-free `serializeSelectionContext`
 * (`@aline/common`) with the canonical document-context options, so the
 * "Add to Chat" mention builder and the clipboard copy path share one entry
 * point. Stays client-side by design: `serializeSelectionContext` never touches
 * a live editor.
 */
export function serializeSelectionFromRange(editor: AlineEditor, range: Range): string {
  const selectionInfo = getSelectionInfoFromRange(editor, range);
  /**
   * No tokenizer is available client-side and we don't know which model will
   * read this, so we measure with `text.length` — i.e. we budget by characters,
   * not tokens. The knobs in `SELECTION_EXPAND_OPTIONS` are character counts to
   * match (see its definition). Since `maxTokenBudget` there is `Infinity`, the
   * only budget this actually drives is the per-table character limit.
   */
  return serializeSelectionContext(
    editor.children,
    selectionInfo,
    { ...SELECTION_EXPAND_OPTIONS, estimateTokens: text => text.length },
    DOCUMENT_CONTEXT_SERIALIZE_OPTIONS
  );
}
